export const DONATION_PAYMENT_FAIL_MESSAGE = 'Оплата не удалась, проверьте баланс или данные карты';
